<template>
  <div id="app">
    <div v-if="visible" class="info-box">
      <div class="actualite">Actualités</div>
      <div v-for="item in sortedItems" :key="item.id">
        <div id="info-title">{{item.titre}}</div>
        <div id="info-date">{{item.date}}</div>
        <p id="info-text">{{item.description}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import db from '@/plugins/firebase'
export default {
  name: "app",
  data() {
    return {
      visible: false,
      sortedItems: []
    };
  },
  created(){
    db.collection('actu').get()
      .then(querySnapshot => {
        let tempItems = []
        querySnapshot.forEach(el => {
          const data = {
            id: el.id,
            titre: el.data().titre,
            description: el.data().description,
            date: el.data().date,
            timestamp: el.data().timestamp
          }
          tempItems.push(data)
        });
        this.sortedItems = tempItems.sort((a,b) => {
          return a.timestamp.seconds > b.timestamp.seconds ? -1 : 1
        })
        if (this.sortedItems.length != 0){
          this.visible = true
        }
      })
  }
};
</script>

<style>
.info-box {
  position: absolute;
  bottom: 20px;
  right: 20px;

  background-color: white;
  border-radius: 10px;

  padding: 10px;
  max-width: 400px;

  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.2);
}
#info-title {
  text-transform: uppercase;
  font-weight: 700;
}
#info-date {
  font-size: 12px;
}

#info-text {
  font-size: 14px;
}

.actualite {
  position: absolute;
  top: -20px;
  right: 20px;

  text-transform: uppercase;
  font-weight: 900;
  font-size: 18px;

  color: white;
}

.hidden {
  visibility: hidden;
}

@media screen and (max-width: 600px) {
  .info-box {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);

    width: 80%;
    
    background-color: white;
    border-radius: 10px;

    padding: 10px;
    max-width: 400px;

    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.2);
  }
}
</style>
